import * as React from 'react';
/**
 *
 * Original name: thumbs down
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3704%3A526
 *
 */
export const ThumbsDownSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { d: "m100.1 58.863-8.067-33A8.978 8.978 0 0 0 83.29 19H55.02c-3.79.003-7.52.94-10.861 2.726L19 35.2V70h11.888a10.98 10.98 0 0 1 5.949 1.747l6.39 4.108a11.039 11.039 0 0 1 4.487 5.775L54.838 103h4.738A17.002 17.002 0 0 0 75.7 80.624L72.162 70h19.194a9 9 0 0 0 8.744-11.137Zm-6.383 3.99A2.982 2.982 0 0 1 91.356 64H63.838l6.173 18.521A11 11 0 0 1 59.576 97h-.414l-5.755-17.268a17.06 17.06 0 0 0-6.935-8.924L40.081 66.7a16.965 16.965 0 0 0-9.193-2.7H25V38.8l21.992-11.785A17.058 17.058 0 0 1 55.02 25h28.27a2.992 2.992 0 0 1 2.91 2.288l8.067 33a2.982 2.982 0 0 1-.551 2.565h.001Z", fill: "currentColor" })));
